import React from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';

import { ContentrArea } from '@ttstr/components';

const ContactPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <article>
      <Container className="list-page my-5">
        <Helmet>
          <title>Anfragen</title>
          <body className="sozialticket-page" />
        </Helmet>
        <h1 className="mb-5">Anfragen</h1>
        <ContentrArea id="contact-page-content" />
      </Container>
    </article>
  );
};

export default React.memo(ContactPage);
